import * as Yup from 'yup';

// Wizard step 1 — pick the build-source ImageName.
export const sourceImageStepSchema = Yup.object().shape({
  ImageName: Yup.string().required().label('Source image'),
});

// Wizard step 2 — two-level target pick (App Instance -> its ContainerApp). RV-2: there
// is no flat container-list endpoint, so both levels are required before "Next" enables.
export const targetContainerStepSchema = Yup.object().shape({
  AppInstanceId: Yup.string().required().label('App Instance'),
  ContainerAppId: Yup.number().required().label('Target container'),
});

// Wizard step 3 — pipeline name; server also enforces the 1:1 constraint (400 on conflict).
// Whitespace-only input is rejected with the same "Name is required" message as empty
// input (TC-DPW-010) rather than a generic "must be a trimmed string" Yup default.
const notBlank = (value) => !!value && value.trim().length > 0;

export const nameStepSchema = Yup.object().shape({
  Name: Yup.string()
    .max(255)
    .required('Name is required')
    .test('not-blank', 'Name is required', notBlank),
});

// Wizard step 4 / list "Run" — PAT is required, non-empty only (OQ-4 default: no format
// validation beyond non-empty). NEVER given a default value (NFR-Security).
export const runStepSchema = Yup.object().shape({
  AccessToken: Yup.string().trim().min(1).required().label('Git Personal Access Token'),
});

// Inline Edit dialog (AC-19) — same shape as create, all fields optional individually
// since PATCH is partial, but the form always presents a complete, valid combination.
export const editPipelineSchema = Yup.object().shape({
  Name: Yup.string()
    .max(255)
    .required('Name is required')
    .test('not-blank', 'Name is required', notBlank),
  ImageName: Yup.string().required().label('Source image'),
  ContainerAppId: Yup.number().required().label('Target container'),
});
